import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Icon, VisuallyHidden } from '@zapier/design-system';
const Styles = labelStyles('SearchTogglerInApp', {
    root: (size) => css `
    height: 36px;
    border-radius: var(--zds-radius-small, 3px);
    display: flex;
    align-items: center;
    gap: var(--zds-space-4, 4px);
    padding: ${size === 'medium'
        ? ' 10px var(--zds-space-12, 12px)'
        : '10px var(--zds-space-4, 4px)'};
    justify-content: center;
    color: var(--zds-text-default, #413735);
    font-weight: 500;

    &:hover,
    &:focus {
      color: var(--zds-text-default, #413735);
      background-color: var(--zds-background-stronger, #f5f3eb);
    }
  `,
});
const SearchToggler = (props) => {
    return (jsx("label", { css: Styles.root(props.size), htmlFor: props.id, "data-zds": true },
        jsx(Icon, { name: props.isSearching ? 'formX' : 'navSearch', size: 24 }),
        props.size !== 'small' ? ('Search') : (jsx(VisuallyHidden, null, "Search"))));
};
export default SearchToggler;
//# sourceMappingURL=SearchToggler.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
